module.exports = __webpack_public_path__ + "img/agro.25fd13e9.svg";